import React, { useState, useEffect } from 'react';
import AdminUserTransactionTable from "../../../components/tables/AdminUserTransactionTable";
import {getAdminUserTransactions} from "../../../store/action/user";

const AdminUserTransaction = ({user,token}) => {
    const [ transactions, setTransactions ] = useState([]);
    const [ loading, setloading ] = useState(true);

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            console.log("masuk");
            const resTrx = await getAdminUserTransactions(user.id,token);
            if (resTrx.success) {
                const us = resTrx.transactions;
                const trx = us.reduce((result, i) => {
                    result.push({
                        id:i.id,
                        referenceId:i.reference_id,
                        amount:i.amount,
                        paymentMethod:i.payment_method,
                        paymentCategory:i.payment_category,
                        status:i.status,
                        type:i.type,
                        balance:i.balance,
                        createdAt:i.created_at
                    });
                    return result
                }, []);
                setTransactions(trx)
            } else {
                alert(resTrx.error)
            }

        } catch (e) {
            console.log (e);
            alert(e.message)
        }
        setloading(false)
    };

    const onRefresh = () => {
        _fetchData()
    };


    if (loading) {
        return <p>Loading...</p>
    }

    return (
        <div>
            <AdminUserTransactionTable
                data={transactions}
            />
        </div>
    )
};



export default AdminUserTransaction;
